var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,24H3.158c-.028,0-.051-.014-.079-.016S3.028,24,3,24a1,1,0,0,1-1-1V19H1a1,1,0,0,1,0-2H2V13H1a1,1,0,0,1,0-2H2V7H1A1,1,0,0,1,1,5H2V1A1,1,0,0,1,3,0c.028,0,.052.014.079.016S3.13,0,3.158,0H18a3,3,0,0,1,3,3V21A3,3,0,0,1,18,24ZM4,5A1,1,0,0,1,4,7v4a1,1,0,0,1,0,2v4a1,1,0,0,1,0,2v3H15V2H4ZM19,3a1,1,0,0,0-1-1H17V22h1a1,1,0,0,0,1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteHistory);
export default __webpack_public_path__ + "static/media/note-history.e5647d06e93ec41aba95627c2738cda4.svg";
export { ForwardRef as ReactComponent };